export default "/images/2f25551539706759a8cec428df01d9dd.avif";